"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _WebChatReduxContext = require("../WebChatReduxContext");

var _useForceRender = _interopRequireDefault(require("./internal/useForceRender"));

var _useStyleOptions3 = _interopRequireDefault(require("./useStyleOptions"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function useActiveTyping(expireAfter) {
  var now = Date.now();

  var _useStyleOptions = (0, _useStyleOptions3.default)(),
      _useStyleOptions2 = _slicedToArray(_useStyleOptions, 1),
      typingAnimationDuration = _useStyleOptions2[0].typingAnimationDuration;

  var forceRender = (0, _useForceRender.default)();
  var typing = (0, _WebChatReduxContext.useSelector)(function (_ref) {
    var typing = _ref.typing;
    return typing;
  });

  if (typeof expireAfter !== 'number') {
    expireAfter = typingAnimationDuration;
  }

  var activeTyping = Object.entries(typing).reduce(function (activeTyping, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        id = _ref3[0],
        _ref3$ = _ref3[1],
        at = _ref3$.at,
        name = _ref3$.name,
        role = _ref3$.role;

    var until = at + expireAfter;

    if (until > now) {
      return _objectSpread({}, activeTyping, _defineProperty({}, id, {
        at: at,
        expireAt: until,
        name: name,
        role: role
      }));
    }

    return activeTyping;
  }, {});
  var earliestExpireAt = Math.min.apply(Math, _toConsumableArray(Object.values(activeTyping).map(function (_ref4) {
    var expireAt = _ref4.expireAt;
    return expireAt;
  })));
  var timeToRender = earliestExpireAt && earliestExpireAt - now;
  (0, _react.useEffect)(function () {
    if (timeToRender && isFinite(timeToRender)) {
      var timeout = setTimeout(forceRender, Math.max(0, timeToRender));
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [forceRender, timeToRender]);
  return [activeTyping];
}

var _default = useActiveTyping;
exports.default = _default;